import React from "react";
import { Tooltip } from "antd";
import moment from "moment";

// 公用js方法
// 获取某个工艺单元对应图标
export const getIcons = (name) => {
  let res = {
    格栅渠: "iconicon_gongyidanyuan_gezhaqu_32",
    厌氧池: "iconicon_gongyidanyuan_yanyangchi_32",
    清水池: "iconicon_gongyidanyuan_qingshuichi_32",
    D型滤池: "iconicon_gongyidanyuan_Dxinglvchi_32",
    好氧池: "iconicon_gongyidanyuan_haoyangchi_32",
    沉淀池: "iconicon_gongyidanyuan_chendianchi_32",
    兼氧池: "iconicon_gongyidanyuan_jianyangchi_32",
    调节池: "iconicon_gongyidanyuan_tiaojiechi_32",
    污泥池: "iconicon_gongyidanyuan_wunichi_32",
    加药: "iconicon_gongyidanyuan_jiayaojian_32",
    机电间: "iconicon_gongyidanyuan_jidianjian_32",
  };

  return res[name] || "iconicon_gongyidanyuan_Dxinglvchi_32";
};
export const treeIds = { id: "" };

export const treeConversion = (values, parent = "") => {
  let ids = "";
  let data =
    values &&
    values.map((v, i) => {
      let obj = {
        title: v.name || v.item,
        key: v.id,
        value: v.id,
        parent: parent,
      };
      let childData = v.children || v.patrolItemVOS;
      if (childData && childData.length > 0) {
        obj.children = treeConversion(
          childData,
          parent ? parent + "," + obj.key : obj.key,
        );
      } else {
        ids = ids + "," + obj.key;
        // setChildIds(childIds + ',' + obj.key)
      }
      return obj;
    });
  treeIds.id = treeIds.id + "," + ids;
  return data;
};

// 处理工艺流程数据
export const matchZGJData = (myResIdArr, data) => {
  let map = {};
  let resDest = [];
  //故障设备id集合
  let isGZArr = [];
  // 停止设备id集合
  let isTZArr = [];
  let devIds = myResIdArr.map((mm) => mm.devId);
  devIds = [...new Set(devIds)];
  devIds.map((nn) => {
    myResIdArr.map((mm) => {
      if (nn == mm.devId) {
        // 故障
        if (mm.gatherDevPointValue.split("_")[2] == "ZG" && mm.val == 1) {
          isGZArr.push(nn);
        }
        // 停止
        if (mm.gatherDevPointValue.split("_")[2] == "QT" && mm.val == 0) {
          isTZArr.push(nn);
        }
      }
    });
  });
  for (let i = 0; i < myResIdArr.length; i++) {
    let ai = myResIdArr[i];
    if (!map[ai.deviceName]) {
      //此处插入的数据结构可根据需求，自我定制
      let statusKey = ai.gatherDevPointValue.split("_");

      if (statusKey[3] == "T") {
        resDest.push({
          ...ai,
          dataType: statusKey[3],
          [`${statusKey[2]}`]: ai.val,
          processunitId: data.processunitId,
          processunitName: data.processunitName,
          processunitValue: data.processunitValue,
        });
      } else {
        resDest.push({
          ...ai,
          type: statusKey[3],
          status: ai.type,
          processunitId: data.processunitId,
          processunitName: data.processunitName,
          processunitValue: data.processunitValue,
        });
      }
      map[ai.deviceName] = ai;
    } else {
      for (let j = 0; j < resDest.length; j++) {
        let dj = resDest[j];

        if (dj.deviceName == ai.deviceName) {
          let statusKey = ai.gatherDevPointValue.split("_");

          if (statusKey[3] == "T") {
            dj = {
              ...dj,
              dataType: statusKey[3],
              [`${statusKey[2]}`]: ai.val,
            };
          } else {
            dj = {
              ...dj,
              dataType: statusKey[3],
              status: ai.type,
            };
          }

          dj = {
            ...dj,
            processunitId: data.processunitId,
            processunitName: data.processunitName,
            processunitValue: data.processunitValue,
          };
          resDest[j] = dj;

          break;
        }
      }
    }
  }
  resDest.map((mm) => {
    mm.isGZDev = false;
    mm.isTZDev = false;
    mm.alarm = data.alarm; // 工艺单元是否含有故障设备，0无，1有
    if (isGZArr.indexOf(mm.devId) > -1) {
      mm.isGZDev = true;
    }
    if (isTZArr.indexOf(mm.devId) > -1) {
      mm.isTZDev = true;
    }
  });
  return resDest; //resDest[i].totalCount即为resDest[i].typeName该大类下的数据list，遍历渲染即可
};

export const getStationData = (ids, names) => {
  let data = [];
  if (ids.includes(",")) {
    let stationData = ids.split(",").map((v, i) => {
      return {
        title: names.split(",")[i],
        value: v - 0,
        checked: false,
      };
    });
    data = [{ value: -1, title: "全部", checked: false }, ...stationData];
  } else {
    data = [{ value: ids, title: names, checked: false }];
  }
  return data;
};
// 获取所有的ID
export const extraIds = (nodes) => {
  return (
    nodes &&
    nodes.map((v) => {
      if (v.children && v.children.length === 0) {
        return [v.node.key, v.node.props.parent.split(",")];
      } else {
        return extraIds(v.children);
      }
    })
  );
};

// 标识符
export const identifierData = [
  "maintain_technician", // 维修技师
  "area_manager", // 区域经理
];

// 周期
export const cycleData = [
  { label: "天", value: "day" },
  { label: "周", value: "week" },
  { label: "月", value: "month" },
  { label: "季", value: "quarter" },
  { label: "年", value: "year" },
];
// 周期 key
export const cycleKey = {
  day: "天",
  week: "周",
  month: "月",
  quarter: "季",
  year: "年",
};

// 处理巡检设备
export function getTreeData(data, valueType = "string") {
  for (var i = 0; i < data.length; i++) {
    const value = data[i].id;
    if (data[i].child.length < 1) {
      data[i].children = null;
      data[i].label = data[i].itemName;
      data[i].value = valueType == "string" ? value + "" : value * 1;
    } else {
      data[i].label = data[i].itemName;
      data[i].value = valueType == "string" ? value + "" : value * 1;
      data[i].children = data[i].child;
      getTreeData(data[i].child, valueType);
    }
  }
  return data;
}

// 查找所有父元素
export function findAllParents(
  data,
  id,
  arr,
  type = "string",
  children = "child",
) {
  let stark = [];
  stark = stark.concat(data);
  while (stark.length) {
    const temp = stark.shift();
    if (temp.id == id) {
      const id = type === "string" ? temp.id + "" : temp.id * 1;
      arr.unshift(id);
      return findAllParents(data, temp.pid, arr, type, children);
    }
    if (temp[children]) {
      stark = stark.concat(temp[children]);
    }
  }
  return arr;
}

// 找出当前设备
export function findCurrentDevices(data, id, arr) {
  data.forEach((item) => {
    if (item.id == id) {
      arr.push(item);
    } else {
      findCurrentDevices(item.child, id, arr);
    }
  });
  return arr;
}

// 根据字段长度进行显示方式
export function toolMouseTip(str, strShowLen) {
  if (str) {
    if (str.length > strShowLen) {
      return (
        <Tooltip placement="top" title={str}>
          {str.substring(0, strShowLen) + "…"}
        </Tooltip>
      );
    } else {
      return str;
    }
  } else {
    return "-";
  }
}

// 去掉工单最后一个child
export function getOrderTreeData(data) {
  for (var i = 0; i < data.length; i++) {
    if (data[i].child.length < 1) {
      data[i].child = null;
    } else {
      getOrderTreeData(data[i].child);
    }
  }
  return data;
}

// 指令单状态
export function instructStatus(status) {
  let txt = "";
  if (status == 0) {
    txt = "待处理";
  } else if (status == 0) {
    txt = "处理中";
  } else if (status == 1) {
    txt = "完成";
  } else if (status == 2) {
    txt = "关闭";
  }
  return txt;
}

// 缺陷单状态
export function defectStatus(status) {
  let txt = "";
  if (status == -1) {
    txt = "未生效";
  } else if (status == 0) {
    txt = "待处理";
  } else if (status == 1) {
    txt = "处理中";
  } else if (status == 2) {
    txt = "完成";
  } else if (status == 3) {
    txt = "关闭";
  } else if (status == 4) {
    txt = "验收";
  }
  return txt;
}

// 缺陷单状态的颜色值
export function defectStatusColor(status) {
  let txt = "";
  if (status == -1) {
    txt = "#BDBDBD";
  } else if (status == 0) {
    txt = "#FF3819";
  } else if (status == 1) {
    txt = "#2db7f5";
  } else if (status == 2) {
    txt = "#87d068";
  } else if (status == 3) {
    txt = "#BDBDBD";
  } else if (status == 4) {
    txt = "#108ee9";
  }
  return txt;
}

// 判断是否存在值
export function isHaveVal(val) {
  if (val != undefined && val != null && val !== "") {
    return `${val}`;
  }
  return undefined;
}

// 获取url参数
export function getUrlCode(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href,
      ) || [, ""])[1].replace(/\+/g, "%20"),
    ) || null
  );
}
export const getArea = (name) => {
  let res = {
    膜池设备房: ["MBR-设备间"],
    MBR膜池: ["1#MBR池", "2#MBR池", "3#MBR池", "4#MBR池"],
    粗细格栅: ["粗格栅", "细格栅"],
    调节池: ["调节池"],
    生化池: ["生化池", "生化池02"],
    反硝化滤池: [
      "1#反硝化滤池",
      "2#反硝化滤池",
      "3#反硝化滤池",
      "4#反硝化滤池",
      "反硝化滤池风机",
      "反硝化滤阀门间",
    ],
    鼓风机房: ["1#风机房"],
    加药间: ["药剂间", "碳源加药间", "次氯酸钠加药间"],
    膜格栅: ["膜格栅冲洗泵"],
    水解酸化: ["水解酸化池"],
    在线监测: ["进水口", "出水口"],
    应急池: ["事故池"],
    脱水机房: ["脱泥间-车库"],
  };

  return res[name] || [];
};

// 取区间数值
export const rangeNumber = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};

// 禁用日期
export const disabledDate = (current, timeLimit) => {
  const begetTime = moment(timeLimit[0]);
  const endTime = moment(timeLimit[1]);

  if (timeLimit.length == 2) {
    return (
      (current && current < begetTime) ||
      (current && current > endTime.endOf("day"))
    );
  } else {
    return false;
  }
};

// 禁用时间
export const disabledTime = (current, type, timeLimit) => {
  if (timeLimit.length === 0) return {};
  let [start, end] = timeLimit;
  if (type === "start") {
    if (current && current.isSame(moment(start), "day")) {
      const h = moment(start).hour();
      const m = moment(start).minute();
      const s = moment(start).second();
      return {
        disabledHours: () => rangeNumber(0, h),
        disabledMinutes: () => (current.hour() === h ? rangeNumber(0, m) : []),
        disabledSeconds: () =>
          current.hour() === h && current.minute() === m
            ? rangeNumber(0, s)
            : [],
      };
    }
  } else {
    if (current && current.isSame(moment(end), "day")) {
      const h = moment(end).hour();
      const m = moment(end).minute();
      const s = moment(end).second();
      return {
        disabledHours: () => rangeNumber(h + 1, 24),
        disabledMinutes: () =>
          current.hour() === h ? rangeNumber(m + 1, 60) : [],
        disabledSeconds: () =>
          current.hour() === h && current.minute() === m
            ? rangeNumber(s + 1, 60)
            : [],
      };
    }
  }
  return {};
};
